const CLIENTAPI = {
    ADDCLIENT: `/clients/client`,
    PATCHCLIENT: (productid) => `clients/client/${productid}`,
    GETCLIENTS: `clients/clients`
}

export default CLIENTAPI;